import { sunoCommsApi } from "../api-base";
import type { JWTTokenResponse } from "../types/suno-comms-auth.type";

export const authEndpoints = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createJwtToken: builder.mutation<JWTTokenResponse, string>({
      query: (api_key: string) => ({
        url: "/auth/jwt/create",
        method: "POST",
        body: {
          api_key,
          role: "user"
        }
      }),
      invalidatesTags: ["CommsAuth"]
    })
  })
});

export const { useCreateJwtTokenMutation } = authEndpoints;
